module.exports = __webpack_public_path__ + "static/media/curling.ea2ec4ac.svg";